import { GlRepository } from "../repositories/GlRepository";
import { GlsResultEntity } from "../entities/GlEntity";

/**
 * Get GLs Use Case
 * Fetches GL list with pagination and optional search
 */
export class GetGlsUseCase {
  constructor(private repository: GlRepository) {}

  async execute(
    limit: number = 20,
    offset: number = 0,
    search?: string,
    management?: boolean
  ): Promise<GlsResultEntity> {
    if (limit < 1 || limit > 100) {
      throw new Error("Limit must be between 1 and 100");
    }
    if (offset < 0) {
      throw new Error("Offset must be >= 0");
    }
    return this.repository.fetchGls({ limit, offset, search, management });
  }
}
